exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumbs[data-v-28317240] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n@media (min-width: 1024px) {\n.breadcrumbs[data-v-28317240] {\n    margin-bottom: 16px;\n}\n}\n.breadcrumbs .breadcrumb[data-v-28317240] {\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  --tw-text-opacity: 1;\n  color: rgba(174, 178, 187, var(--tw-text-opacity));\n  white-space: nowrap;\n}\n.breadcrumbs .separator[data-v-28317240] {\n  padding-left: 8px;\n  padding-right: 8px;\n  --tw-text-opacity: 1;\n  color: rgba(174, 178, 187, var(--tw-text-opacity));\n}", ""]);

// exports
